import { memo, ReactElement } from 'react';
import { useAtomValue } from 'jotai';
import { Tag } from 'antd';
import type { Branch } from '../types';
import { forwardToTokyoAtomFamily, scheduleAtomFamily } from '../atoms/settingAtoms';
import { isScheduleDirty } from '../utils/isScheduleDirty';
import { TabLabel, UnsavedDot } from './styles';

interface Props {
  branch: Branch;
}

// タブを切り替えると中身が見えなくなるため、開いていない拠点でも気付く必要がある状態
// （未保存の編集・東京拠点への転送中）をラベル側に出す。
const BranchTabLabel = memo(function BranchTabLabel({ branch }: Props): ReactElement {
  const { current, baseline } = useAtomValue(scheduleAtomFamily(branch.code));
  const forwardToTokyo = useAtomValue(forwardToTokyoAtomFamily(branch.code));

  return (
    <TabLabel>
      {branch.label}
      {/* 未保存の目印は稼働時間の変更のみを対象とし、祝日・年末年始のトグルは含めない */}
      {isScheduleDirty(current.weekdays, baseline.weekdays) && <UnsavedDot role='img' aria-label='未保存の変更あり' />}
      {forwardToTokyo && <Tag color='processing'>東京へ転送中</Tag>}
    </TabLabel>
  );
});

export default BranchTabLabel;
